<template>
    <div ref="sidebarMain" class="sidebar-main">
        <img @click="collapseSidebar" ref="toggleBtn" class="toggle-btn" src="@/assets/images/arrow-left.svg"/>
        <div v-if="isExpanded" class="d-flex flex-column justify-content-between h-100">
            <div>
                <div class="logo-data">
                    <img src="@/assets/images/logo.svg"/>
                </div>
                <div class="account-data">
                    <Avatar :label="currentUser && currentUser.username  ? currentUser.username[0] : ''" class="avatar-icon" shape="circle" />
                    <p class="username mt-1"> {{currentUser && currentUser.username ? currentUser.username : ''}} </p>
                </div>
                <nav>
                    <ul class="sidebar-list">
                        <li
                            class="sidebar-elements"
                            v-for="(comp, index) in sidebar_components"
                            :key="index"
                        >
                            <router-link
                                v-if="!comp.child"
                                exact-active-class="exact-active"
                                :to="comp.route"
                                class="link-style"
                                @click="sidebarState(index)"
                            >
                                <div @mouseover="comp.isHover=true" @mouseleave="comp.isHover=false" v-if="index !== activeIndex" class="d-flex align-items-center">
                                    <img
                                        :src=" comp.isHover ? comp.hover_image_src : comp.image_src"
                                        class="sidebar-image"
                                    />
                                    <p :class="comp.isHover ? 'comp-hover' : 'comp-name'">
                                        {{ comp.name }}
                                    </p>
                                </div>
                                <div @mouseover="comp.isHover=true" @mouseleave="comp.isHover=false" v-else class="d-flex align-items-center sidebar-active-div">
                                    <img
                                        :src="comp.active_image_src"
                                        class="sidebar-active-image"
                                    />
                                    <p class="name-active-div">
                                        {{ comp.name }}
                                    </p>
                                </div>
                            </router-link>
                            <div v-else>
                                <div @mouseover="comp.isHover=true" @mouseleave="comp.isHover=false" class="d-flex align-items-center cursor-pointer" @click="comp.isExapanded = !comp.isExapanded" v-if="index !== activeIndex">
                                    <img
                                        :src=" comp.isHover ? comp.hover_image_src : comp.image_src"
                                        class="sidebar-image"
                                    />
                                    <p :class="comp.isHover ? 'comp-hover' : 'comp-name'">
                                        {{ comp.name }}
                                    </p>
                                    <div class="mx-2">
                                        <div v-if="!comp.isExapanded">
                                            <img v-if="comp.isHover" src="@/assets/images/arrow-down-hover.svg"/>
                                            <img v-else src="@/assets/images/arrow-down.svg"/>
                                        </div>
                                        <div v-else>
                                            <img v-if="comp.isHover" src="@/assets/images/arrow-up-hover.svg"/>
                                            <img v-else src="@/assets/images/arrow-up.svg"/>
                                        </div>
                                    </div>
                                </div>
                                <div @mouseover="comp.isHover=true" @mouseleave="comp.isHover=false" v-else class="d-flex align-items-center sidebar-active-div cursor-pointer" @click="comp.isExapanded = !comp.isExapanded">
                                    <img
                                        :src="comp.active_image_src"
                                        class="sidebar-active-image"
                                    />
                                    <p class="name-active-div">
                                        {{ comp.name }}
                                    </p>
                                    <div class="mx-2">
                                        <div v-if="!comp.isExapanded">
                                            <img src="@/assets/images/arrow-down-selected.svg"/>
                                        </div>
                                        <div v-else>
                                            <img src="@/assets/images/arrow-up-selected.svg"/>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="comp.isExapanded">
                                    <div v-for="(subComp, subIndex) in comp.child" :key="subIndex">
                                        <router-link
                                            exact-active-class="exact-active"
                                            :to="subComp.route"
                                            class="link-style"
                                            @click="sidebarState(index, subIndex)"
                                        >
                                            <div @mouseover="subComp.isHover=true" @mouseleave="subComp.isHover=false" class="d-flex align-items-center sub-comp-div">
                                                <span class="dot" :class="(subComp.isHover || (subIndex === activeSubIndex)) && (index===activeIndex) ? 'dot-hover' : ''"/>
                                                <p class="sub-comp-name" :class="(subComp.isHover || (subIndex === activeSubIndex)) && (index===activeIndex) ? 'sub-comp-name-hover' : ''">
                                                   {{ subComp.name }}
                                                </p>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="logout-route">
                <div @click="logout" @mouseover="logoutHover=true" @mouseleave="logoutHover=false" class="logout-div d-flex align-items-center">
                    <img v-if="!logoutHover" class="sidebar-image" src="@/assets/images/logout.svg">
                    <img v-else class="sidebar-image" src="@/assets/images/logout-hover.svg" />
                    <p :class="logoutHover ? 'comp-hover' : 'comp-name'"> Logout </p>
                </div>
            </div>
        </div>
        <div v-else class="d-flex flex-column justify-content-between h-100">
            <div>
                <div class="logo-data logo-small">
                    <img src="@/assets/images/logo-mini.svg"/>
                </div>
                <div class="account-data extra-sapce">
                    <Avatar :label="currentUser && currentUser.username  ? currentUser.username[0] : ''" class="avatar-icon" shape="circle" />
                </div>
                <nav>
                    <ul class="sidebar-mini-list">
                        <li
                            class="sidebar-mini-elements"
                            v-for="(comp, index) in sidebar_components"
                            :key="index"
                            @mouseover="comp.isHover=true" @mouseleave="comp.isHover=false"
                        >
                            <router-link
                                v-if="!comp.child"
                                exact-active-class="exact-active"
                                :to="comp.route"
                                class="link-style"
                                @click="sidebarState(index)"
                            >
                                <div @mouseover="comp.isHover=true" @mouseleave="comp.isHover=false" class="py-2 mx-1 d-flex align-items-center justify-content-center child-parent" :class="index === activeIndex ? 'sidebar-active-div' : ''">
                                    <img v-if="index === activeIndex" :src="comp.active_image_src" />
                                    <img v-else :src=" comp.isHover ? comp.hover_image_src : comp.image_src"/>
                                    <div v-if="comp.isHover" class="menu">
                                        {{ comp.name }}
                                    </div>
                                </div>
                            </router-link>
                            <div class="" v-else>
                                <div class="py-2 mx-1 d-flex align-items-center justify-content-center child-parent" :class="index === activeIndex ? 'sidebar-active-div' : ''">
                                    <img v-if="index === activeIndex" :src="comp.active_image_src" />
                                    <img v-else :src=" comp.isHover ? comp.hover_image_src : comp.image_src"/>
                                    <div v-if="comp.isHover" class="menu menu-align">
                                        <p class=""> {{ comp.name }}</p>
                                        <div v-for="(subComp, subIndex) in comp.child" :key="subIndex" class="mx-2">
                                            <router-link
                                            exact-active-class="exact-active"
                                            :to="subComp.route"
                                            class="link-style"
                                            @click="sidebarState(index, subIndex)"
                                            >
                                                <p
                                                    @mouseover="subComp.isHover=true"
                                                    @mouseleave="subComp.isHover=false"
                                                    class="sub-comp-name-mini"
                                                    :class="subComp.isHover || (subIndex === activeSubIndex) ? 'sub-comp-name-hover' : ''"
                                                >
                                                    {{subComp.name}}
                                                </p>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="mini-componenets" @click="logout" @mouseover="logoutHover=true" @mouseleave="logoutHover=false">
                <img class="" v-if="!logoutHover" src="@/assets/images/logout.svg">
                <img v-else class="" src="@/assets/images/logout-hover.svg" />
                <div v-if="logoutHover" class="logout-menu">
                    Logout
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels, sleep } from '@/utils'

export default {
    name: 'SideBar',
    components: {

    },
    data () {
        return {
            sidebar_components: [
                {
                    image_src: this.$images.dashboards.inactive,
                    active_image_src: this.$images.dashboards.hover,
                    hover_image_src: this.$images.dashboards.hover,
                    name: 'Dashboard',
                    route: '/',
                    isHover: false
                },
                {
                    image_src: this.$images.whitelisting.inactive,
                    active_image_src: this.$images.whitelisting.hover,
                    hover_image_src: this.$images.whitelisting.hover,
                    name: 'CTA Whitelisting',
                    // route: '/cta',
                    isHover: false,
                    isExapanded: false,
                    child: [
                        {
                            name: 'Single CTA',
                            route: '/cta',
                            isHover: false
                        },
                        {
                            name: 'Bulk Whitelisting',
                            isHover: false,
                            route: '/cta/bulk'
                        }
                    ]
                },
                {
                    image_src: this.$images.urlShortener.inactive,
                    active_image_src: this.$images.urlShortener.hover,
                    hover_image_src: this.$images.urlShortener.hover,
                    name: 'URL Shortener',
                    // route: '/link',
                    isHover: false,
                    isExapanded: false,
                    child: [
                        {
                            name: 'Single URL',
                            route: '/link',
                            isHover: false
                        },
                        {
                            name: 'Bulk Shortening',
                            isHover: false,
                            route: '/link/bulk'
                        }
                    ]
                },
                // {
                //     image_src: this.$images.domains.inactive,
                //     active_image_src: this.$images.domains.hover,
                //     hover_image_src: this.$images.domains.hover,
                //     name: 'Branded Domains',
                //     route: '/domain',
                //     isHover: false
                // },
                {
                    image_src: this.$images.analytics.inactive,
                    active_image_src: this.$images.analytics.hover,
                    hover_image_src: this.$images.analytics.hover,
                    name: 'Analytics',
                    route: '/analytics',
                    isHover: false
                }
                // {
                //     image_src: this.$images.webhook.inactive,
                //     active_image_src: this.$images.webhook.hover,
                //     hover_image_src: this.$images.webhook.hover,
                //     name: 'Webhooks',
                //     route: '/webhook',
                //     isHover: false
                // },
                // {
                //     image_src: this.$images.settings.inactive,
                //     active_image_src: this.$images.settings.hover,
                //     hover_image_src: this.$images.settings.hover,
                //     name: 'Settings',
                //     isHover: false,
                //     isExapanded: false,
                //     child: [
                //         {
                //             name: 'Subscription',
                //             route: '/subscription',
                //             isHover: false
                //         },
                //         {
                //             name: 'User Management',
                //             isHover: false,
                //             route: '/users'
                //         },
                //         {
                //             name: 'Account Settings',
                //             isHover: false,
                //             route: '/accountsettings'
                //         },
                //         {
                //             name: 'Application Branding',
                //             isHover: false,
                //             route: '/appbranding'
                //         }
                //     ]
                // }
            ],
            activeIndex: 0,
            activeSubIndex: null,
            logoutHover: false,
            isExpanded: true
        }
    },
    methods: {
        sidebarState (index, subIndex) {
            this.activeIndex = index
            this.activeSubIndex = subIndex
        },
        async logout () {
            const resp = await this.$store.dispatch('Auth/Logout/logout')
            if (resp) {
                this.$router.push('/signin')
            }
        },
        async collapseSidebar () {
            this.$refs.toggleBtn.classList.toggle('expand-btn')
            this.$refs.sidebarMain.classList.toggle('collapse')
            if (!this.isExpanded) {
                await sleep(250)
            }
            this.isExpanded = !this.isExpanded
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters({ currentUser: 'currentUser' })
    },
    mounted () {
        this.sidebar_components.forEach((item, index) => {
            if (item.child) {
                item.child.forEach((child, subIndex) => {
                    if (child.route === this.$route.path) {
                        this.activeIndex = index
                        this.activeSubIndex = subIndex
                    }
                })
            } else {
                if (item.route.split('/')[1] === this.$route.path.split('/')[1]) {
                    this.activeIndex = index
                }
            }
        })
    },
    watch: {
        $route: {
            handler () {
                this.sidebar_components.forEach((item, index) => {
                    if (item.child) {
                        item.child.forEach((child, subIndex) => {
                            if (child.route === this.$route.path) {
                                this.activeIndex = index
                                this.activeSubIndex = subIndex
                            }
                        })
                    } else {
                        if (item.route.split('/')[1] === this.$route.path.split('/')[1]) {
                            this.activeIndex = index
                        }
                    }
                })
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.sidebar-component {
    height: 100%;
}
.sidebar-main {
    width: 200px;
    height: 100%;
    background-color: white;
    border-right: 3px solid #E9E6E4;
    position: relative;
    transition: width 0.25s;
}
.collapse {
    width: 70px !important;
}
.collapse:not(.show) {
    display: inherit !important;
}
.logo-data {
    height: 54px;
    padding: 0.5rem;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.875rem;
}
.logo-small {
    width: 70px;
}
.sidebar-list {
    align-items: center;
    padding: 1rem;
    list-style-type: none;
}
.sidebar-mini-list {
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 0px;
    list-style-type: none;
}
.sidebar-elements {
  padding: 0rem 0rem 0.5rem 0rem;
}
.sidebar-mini-elements {
  padding: 0rem 0rem 0.5rem 0rem;
  padding-right: 1rem;
  padding-left: 1rem;
  cursor: pointer;
}
.link-style {
    text-decoration: none;
}
.account-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.username {
    color: black;
    margin: 0;
}
.usertype {
    font-size: 12px;
    color: #2F30434D;
}
.logout-route {
    text-decoration: none;
    padding: 1rem;
    margin-bottom: 1rem;
}
.logout-div {
    border-top: 1px solid #E9E6E4;
    cursor: pointer;
}
.toggle-btn {
    position: absolute;
    left: 187px;
    top: 100px;
    cursor: pointer;
    transition: left 0.25s;
}
.expand-btn {
    left: 57px;
    transform: rotate(180deg);
}
.sidebar-image {
  margin: 0.5rem 1rem 0.5rem 0.5rem;
}
.sidebar-active-image {
  margin: 0.5rem 1rem 0.5rem 0.5rem;
  /* background-color: var(--primary-color); */
}
.sidebar-active-div {
  /* background-color: var(--primary-color); */
  border-radius: 10px;
}
.comp-name {
  color: #495057;
  text-align: center;
  margin-bottom: 0;
}
.comp-hover {
    color: var(--primary-color);
    text-align: center;
    margin-bottom: 0;
}
.name-active-div {
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 0;
}
.sub-comp-div {
    margin: 0.5rem 0.5rem 0.5rem 2rem;
    font-size: 14px;
}
.sub-comp-name {
    text-align: center;
    margin-bottom: 0;
    color: #495057;
    font-size: calc(1rem - 1px);
}
.sub-comp-name-hover {
    color: var(--primary-color) !important;
}
.dot {
    height: 0.25rem;
    width: 0.25rem;
    border-radius: 50%;
    background-color: black;
    margin-right: 0.25rem;
}
.dot-hover {
    background-color: var(--primary-color);
}
.mini-componenets {
    position: relative;
    padding: 1rem;
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 1rem;
}
.extra-sapce {
    margin-bottom: 4rem;
}
.logout-menu {
    position: absolute;
    left: 67px;
    border-left: 3px solid #E9E6E4;
    top: 0;
    z-index: 10000;
    background-color: white;
    padding: .875rem;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 150px;
}
.menu {
    position: absolute;
    z-index: 10000;
    left: calc(70px - 1.5rem);
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: 3px solid #E9E6E4;
    width: 150px;
    color: #495057;
    background-color: white;
    padding: .875rem;
}
.menu-align {
    top: 0;
}
.child-parent {
    position: relative;
}
.sub-comp-name-mini {
    font-size: calc(1rem - 1px);
    color: #495057;
}
</style>
